export default {
  title: 'Tarjouksen kuva',
  select: {
    generate_title: 'Luo kuva tekoälyllä',
    generate_subtitle: 'Luomme kuvan tarjouksesi tietojen perusteella.',
    generate_cta: 'Luo',
    upload_link: 'tai lataa laitteeltasi',
    rate_limit_company: {
      title: 'Tarvitsemme hetken kiriäksemme kiinni',
      description: 'Ravintolasi on luonut paljon kuvia tämän tunnin aikana. Yritä uudelleen {{time}} kuluttua.',
    },
    rate_limit_offer: {
      title: 'Pidetään pieni hengähdystauko',
      description:
        'Näyttää siltä, että olet yrittänyt tätä tarjousta useita kertoja peräkkäin. Olemme taas valmiina {{time}} kuluttua.',
    },
  },
  generating: {
    title: 'Luodaan kuvaasi…',
    progress: {
      cooking: 'Valmistetaan jotain herkullista…',
      plating: 'Annostellaan…',
      finishing: 'Lisätään viimeistelyt…',
    },
  },
  preview: {
    alt: 'Luotu tarjouskuva',
    hint: 'Eikö ihan osunut kohdalleen? Luo uudelleen tai jatka kuvan rajaukseen.',
    click_to_expand: 'Suurenna napsauttamalla',
    regenerate: 'Luo uudelleen',
    continue: 'Jatka muokkaukseen',
  },
  toasts: {
    upload_success: 'Kuva ladattu onnistuneesti.',
    upload_failed: 'Kuvan lataaminen epäonnistui.',
    delete_success: 'Kuva poistettu onnistuneesti.',
    delete_failed: 'Kuvan poistaminen epäonnistui.',
    generate_success: 'Kuva luotu onnistuneesti.',
    generate_failed: 'Kuvan luonnin aloittaminen epäonnistui.',
    generate_timeout: 'Kuvaa luodaan vielä. Se ilmestyy tähän, kun se on valmis.',
    rate_limit_company: 'Tunnin kuvaraja saavutettu tälle ravintolalle. Yritä uudelleen {{time}} kuluttua.',
    rate_limit_offer: 'Hieman liian monta yritystä tälle tarjoukselle juuri nyt — yritä uudelleen {{time}} kuluttua.',
  },
  time: {
    seconds_one: '1 sekunti',
    seconds_other: '{{count}} sekuntia',
    minutes_one: '1 minuutti',
    minutes_other: '{{count}} minuuttia',
    hours_one: '1 tunti',
    hours_other: '{{count}} tuntia',
  },
};
